import moment from "moment";

export default function convertDateToUTC(date: string) {
  const utc = moment(date, "YYYY-MM-DDTHH:mm:ssZ").utc();
  return utc.format();
}
